import { api } from "./apiClient";

export const bugReportsAPI = {
  create: ({
    reportType,
    title,
    description,
    projectId,
    pageUrl,
    browserInfo,
    screenSize,
    screenshot,
  }) => {
    const formData = new FormData();
    formData.append("report_type", reportType);
    formData.append("title", title);
    formData.append("description", description);

    if (projectId) formData.append("project_id", String(projectId));
    if (pageUrl) formData.append("page_url", pageUrl);
    if (browserInfo) formData.append("browser_info", browserInfo);
    if (screenSize) formData.append("screen_size", screenSize);
    if (screenshot) formData.append("screenshot", screenshot);

    return api.post("/bug-reports", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  myReports: () => api.get("/bug-reports/my"),

  adminList: () => api.get("/admin/bug-reports"),

  adminGetOne: (reportId) =>
    api.get(`/admin/bug-reports/${reportId}`),

  sendResolutionEmail: (reportId, payload) =>
    api.post(
      `/admin/bug-reports/${reportId}/send-resolution-email`,
      payload,
    ),
};
